import { Box, Card, CardActions, CardMedia, Typography, useMediaQuery } from '@mui/material'
import cardHeader from '../../assets/cardHeader.jpg';
import ActivationForm from './ActivationForm';

const Activation = () => {
    
    const matches = useMediaQuery('(min-width:600px)');

    return (
        <Box className='masthead'>
          <Box sx={{ width: '100%', p: 2, mt: matches ? 20 : 4 }}>
                <Card sx={{ width: matches ? 600 : 360, m: '0 auto', pt: 2, pb: 2 }}>
                    <Typography align='center' variant='h5' color='black' gutterBottom>
                        Activation
                    </Typography>
                    <CardMedia
                        component="img"
                        height="140"
                        image={cardHeader}
                        alt="green iguana"
                    />
                    <CardActions>
                        <ActivationForm />
                    </CardActions>
                </Card>
            </Box>
        </Box>
    )
}

export default Activation